import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ShowcasePage from "./pages/ShowcasePage";
import ProductPage from "./pages/ProductPage";
import WorkflowPage from "./pages/WorkflowPage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./pages/ScrollToTop";
// import ToothCursor from "./components/ToothCursor";
// import  ImageComparisonSlider from "./pages/ImageComparisonSlider";
import { Toaster } from "./components/ui/toaster";




function App() {
  return (
    <div className="App">
      <BrowserRouter>
         <ScrollToTop /> 
         
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/showcase" element={<ShowcasePage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/workflow" element={<WorkflowPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;